import React, { Component } from 'react';
import { Row, Col, Card, Tabs, Drawer } from 'antd';
import { inject, observer } from 'mobx-react';
import JSONPretty from 'react-json-pretty';
import { Position } from './Position';
import { CandleChart } from './Chart';
import { SettingsView } from './SettingsView';
import { PNLView } from './PNLView';
import { PerformanceView } from './PerformanceView';

import { AddLayerDialog } from './AddLayerDialog';
import { CalculatorView } from './CalculatorTab';
const { TabPane } = Tabs;

@inject('store')
@observer
export class TradeView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddLayerDialog: false,
            newLayerPrice: 0
        };
    }

    render() {
        const { config, scalperTa, mmTa } = this.props.store.makoBotStore;
        return (
            <Row gutter={24}>
                <Col md={24}>
                    <CandleChart
                        symbol={config.symbol}
                        addLayerRequest={price => {
                            this.setState({ showAddLayerDialog: true, newLayerPrice: price });
                        }}
                    />
                    <AddLayerDialog
                        price={this.state.newLayerPrice}
                        visible={this.state.showAddLayerDialog}
                        close={() => this.setState({ showAddLayerDialog: false })}
                    />
                </Col>

                <Col md={24}>
                    {/* <Drawer
                        title="Basic Drawer"
                        placement="right"
                        closable={true}
                        visible={true}
                    ></Drawer> */}
                    <Card bordered={false} size={'small'}>
                        <Tabs defaultActiveKey="0">
                            <TabPane tab="Performance" key="0">
                                <PerformanceView />
                            </TabPane>
                            <TabPane tab="Position" key="1">
                                <Position />
                            </TabPane>
                            <TabPane tab="Closed P&amp;L" key="2">
                                <PNLView />
                            </TabPane>

                            <TabPane tab="Settings" key="4">
                                <SettingsView />
                            </TabPane>

                            <TabPane tab="Calculator" key="5">
                                <CalculatorView />
                            </TabPane>
                            {/* <TabPane tab="Debug" key="6">
                                <Card title="MM">
                                    <JSONPretty id="json-pretty" data={mmTa}></JSONPretty>
                                </Card>
                                <Card title="Scalper">
                                    <JSONPretty id="json-pretty" data={scalperTa}></JSONPretty>
                                </Card>
                            </TabPane> */}
                        </Tabs>
                    </Card>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/index.js